


















import { Component, Prop, Vue } from 'vue-property-decorator'

import BaseLink from '@/components/common/BaseLink.vue'

@Component( {
    components: {
        'oe-link': BaseLink
    }
} )
export default class BaseConsent extends Vue {
    get consentSettingsOpen () {
        return this.$store.getters['globalModule/consentSettingsOpen']
    }

    get consentGiven() {
        return this.$store.getters['globalModule/trackingAllowed']
    }

    acceptTracking() {
        this.$store.commit( 'globalModule/setTrackingAllowed', true )

        setTimeout( () => this.closeConsent(), 1000 )
    }

    denyTracking() {
        this.$store.commit( 'globalModule/setTrackingAllowed', false )

        setTimeout( () => this.closeConsent(), 1000 )
    }

    closeConsent() {
        this.$store.commit( 'globalModule/hideConsent' )
    }
}
